import React from "react";
import { Container } from "@material-ui/core";
import { Breadcrumb } from "breadcrumb/Breadcrumb";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { ContactFormComponent } from "components/misc/contactUs/ContactFormComponent";

export default function ContactPage() {
    const { t } = useTranslation();
    return (
        <div>
            <Container>
                <Breadcrumb currentItem={{ itemLabelKey: "breadcrumb.contact" }} />
                <div className={clsx("mv_60")}>
                    <h1 className="mb_15">{t("contactPage.contactForm")}</h1>
                    <p className={"text_bold"}>{t("contactPage.subTitle")}</p>
                    <p className={"mb_25"}>{t("contactPage.description")}</p>
                    <ContactFormComponent />
                </div>
            </Container>
        </div>
    );
}
